/* eslint-disable no-inner-declarations */
import { ConversationsChannels, Message } from 'lib-shared-legacy-types';

/**
 * For the moment we only support text based channels, because search can only
 * be performed on text.
 */
type SupportedChannels = Exclude<
  ConversationsChannels,
  'pstnphone' | 'callback' | 'voicemail'
>;

export type SupportedMessage = Message & {
  channel: SupportedChannels;
};

export const supportedChannels: SupportedChannels[] = [
  'adachat',
  'digitalgeniuschat',
  'kindlychat',
  'facebookmessenger',
  'whatsapp',
  'sms',
  'email',
  'contactform',
  'widgetchat',
  'messenger',
  'twitter',
  'trustpilotreviews',
];

export function isChannelSupported(channel: ConversationsChannels): boolean {
  return supportedChannels.some(
    (supportedChannel) => supportedChannel === channel,
  );
}

export function isMessageSupported(
  message: Message | SupportedMessage,
): message is SupportedMessage {
  const conditions = [
    message.channel ? isChannelSupported(message.channel) : false,
    message.type === 'conversation:wrapup_message',
    message.is_transcript,
  ];

  return conditions.some((c) => c);
}
